// extracted by mini-css-extract-plugin
export default {"label":"RandomLessons_label__kQ4f+","absent":"RandomLessons_absent__kt639"};